import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicPages, publicPageFromLocation } from './view/feature/public/PublicPages';
import './view/feature/public/public.css';
const App = lazy(() => import('./App').then(module => ({ default: module.App })));
const publicPage = publicPageFromLocation(window.location);
document.title = publicPage ? `${publicPage === 'home' ? 'Calls that speak your language' : publicPage === 'support' ? 'Support' : 'Privacy'} | Telx` : 'Telx';
import { AppErrorBoundary } from './AppErrorBoundary';
import './styles.css';
import './view/feature/app/workspace.css';
import './view/feature/credit/credit.css';

createRoot(document.getElementById('root')!).render(<StrictMode><AppErrorBoundary><Suspense fallback={<main className="loading-screen" role="status">Loading Telx…</main>}>{publicPage ? <PublicPages page={publicPage} /> : <App />}</Suspense></AppErrorBoundary></StrictMode>);
